import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
import LearnMoreModalListItem from '../base/LearnMoreModalListItem';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { KNOWLEDGE_BASE_CONNECT_INBOX_URL, KNOWLEDGE_BASE_CREATE_MEETING_URL } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConnectInboxAndCalendarModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('ConnectInboxAndCalendarModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.connectInboxAndCalendar.heading"
    }),
    illustrationName: "connected-inboxes",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.connectInboxAndCalendar.description"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "setup-guide-components.modal.connectInboxAndCalendar.li1"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "setup-guide-components.modal.connectInboxAndCalendar.li2"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "setup-guide-components.modal.connectInboxAndCalendar.li3"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(Link, {
        external: true,
        href: KNOWLEDGE_BASE_CONNECT_INBOX_URL,
        onClick: () => trackLink('connect inbox article'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.modal.readInstructions"
        })
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.connectInboxAndCalendar.p1"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(Link, {
        external: true,
        href: KNOWLEDGE_BASE_CREATE_MEETING_URL,
        onClick: () => trackLink('create meetings article'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.modal.readInstructions"
        })
      })
    })]
  });
};
ConnectInboxAndCalendarModal.propTypes = {
  onClose: PropTypes.func
};
export default ConnectInboxAndCalendarModal;